import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '@paper-monster/web/src/components/common'
import { useSiteConfig } from '@paper-monster/web/src/components/Providers/SiteConfigProvider'

import routes from '@/routes'

import styles from './BuyNowCta.module.scss'

// The SKU and the lead source come from the site config, so the
// attribution names the SKU the link opens.
const BuyNowCta = ({
  messageId = 'cta.buyNow',
  sku: skuProp,
  source: sourceProp,
  promocode,
  variant = 'primary',
  messageProps,
  ...rest
}) => {
  const { defaultSku, sources } = useSiteConfig()
  const sku = skuProp ?? defaultSku
  const source = sourceProp ?? sources.checkout
  const buyInfoString = JSON.stringify({ sku, source, promocode })

  return (
    <Link
      className={variant === 'success' ? '' : styles.link}
      data-buyinfo={buyInfoString}
      messageId={messageProps?.id ? undefined : messageId}
      messageProps={messageProps}
      size="xlarge"
      to={`${routes.signUp}?sku=${sku}${promocode ? `&couponCode=${promocode}` : ''}`}
      variant={variant}
      {...rest}
    />
  )
}

BuyNowCta.propTypes = {
  sku: PropTypes.string,
  source: PropTypes.string,
  promocode: PropTypes.string,
  messageId: PropTypes.string,
  variant: PropTypes.string,
  messageProps: PropTypes.shape({
    id: PropTypes.string,
  }),
}

export default BuyNowCta
